import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface Article {
  title: string;
  description: string;
  link: string;
  icon: string;
}

const relatedArticles: Article[] = [
  {
    title: 'Panduan Perkhidmatan',
    description: 'Ketahui lebih lanjut tentang perkhidmatan dobi kami',
    link: '/service-information',
    icon: 'InformationCircleIcon',
  },
  {
    title: 'Direktori Agent',
    description: 'Cari agent dobi berhampiran anda',
    link: '/agent-directory',
    icon: 'UsersIcon',
  },
  {
    title: 'Daftar Sebagai Agent',
    description: 'Jana pendapatan dari rumah dengan menjadi agent kami',
    link: '/agent-registration',
    icon: 'UserPlusIcon',
  },
  {
    title: 'Hubungi Kami',
    description: 'Dapatkan bantuan langsung dari team kami',
    link: '/contact-page',
    icon: 'PhoneIcon',
  },
];

export default function RelatedArticles() {
  return (
    <div className="mt-12">
      <h3 className="text-2xl font-heading font-bold text-textPrimary mb-6 text-center">
        Artikel Berkaitan
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {relatedArticles.map((article) => (
          <Link
            key={article.title}
            href={article.link}
            className="bg-card border-2 border-border rounded-lg p-4 hover:border-primary hover:shadow-lg transition-all duration-300 transform hover:scale-105 group"
          >
            <div className="w-12 h-12 mb-3 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center group-hover:shadow-brand transition-all duration-300">
              <Icon name={article.icon as any} size={24} className="text-white" />
            </div>
            <h4 className="font-heading font-semibold text-textPrimary mb-2 group-hover:text-primary transition-colors duration-300">
              {article.title}
            </h4>
            <p className="text-sm text-textSecondary font-body">{article.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
